import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['tab', 'panel'];

  connect() {
    console.log('Tab controller connected');
    this.showTab(this.tabTargets[0]);
  }

  switch(event) {
    event.preventDefault();
    this.showTab(event.currentTarget);
  }

  showTab(selectedTab) {
    this.tabTargets.forEach((tab, index) => {
      const panel = this.panelTargets[index];
      if (tab === selectedTab) {
        tab.setAttribute('aria-selected', 'true');
        tab.classList.add('bg-brand-primary', 'text-white');
        tab.classList.remove('bg-white', 'text-[#7fb9f5]');
        panel.classList.remove('hidden');
      } else {
        tab.setAttribute('aria-selected', 'false');
        tab.classList.remove('bg-brand-primary', 'text-white');
        tab.classList.add('bg-white', 'text-[#7fb9f5]');
        panel.classList.add('hidden');
      }
    });
  }
}
